import { QK } from '@/js/consts/query-keys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/vue-query';
import { computed } from 'vue';
import {
    RequestDeleteScheduleCoachJob,
    RequestPostScheduleCoachJob,
    RequestPutScheduleCoachJob,
} from './types';
import {
    deleteScheduleCoachJob,
    getScheduledCoachJobs,
    postScheduleCoachJob,
    putScheduledCoachJob,
} from './scheduleCoachingFormApi';

export const useGetScheduleCoachingForms = () => {
    const queryKey = computed(() => [QK.SCHEDULE_COACHING_FORMS.GET]);

    return useQuery({
        queryKey,
        queryFn: async () => getScheduledCoachJobs(),
    });
};

export const useMutatePutScheduleCoachingJob = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (request: RequestPutScheduleCoachJob) => {
            return await putScheduledCoachJob(request);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [QK.SCHEDULE_COACHING_FORMS.GET],
            });
        },
    });
};

export const useMutateDeleteScheduleCoachingJob = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (coachJobId: RequestDeleteScheduleCoachJob) => {
            return await deleteScheduleCoachJob(coachJobId);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [QK.SCHEDULE_COACHING_FORMS.GET],
            });
        },
    });
};

export const useMutateScheduleCoachingJob = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: [QK.SCHEDULE_COACHING_FORMS.SCHEDULE],
        mutationFn: async (request: RequestPostScheduleCoachJob) => {
            return await postScheduleCoachJob(request);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [QK.SCHEDULE_COACHING_FORMS.GET],
            });
        },
    });
};
